import { Component, OnInit, Input } from '@angular/core';
import { FormValidator } from './../common/services/formValidator.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonConstants } from '../common/utilities/commonConstants';
import { ConfigService } from '../common/services/config.service';
import { HttpInterceptor } from '../common/services/httpInterceptor.service';
import { Formatter } from '../common/services/formatter';
import { ActivitiHandlerService } from '../common/services/activitiHandler.service';
import { RouteHandlerService } from '../common/services/routeHandler.service';
import { SharedService } from '../common/services/sharedService';
import { AnalyticsService } from '../common/services/device.analytics.service';
import { SessionHandlerService } from '../common/services/sessionHandler.service';

@Component({
    selector: 'app-resume-application',
    templateUrl: './resumeApplication.template.html',
    styleUrls: ['./resumeApplication.style.scss']
})
export class ResumeApplicationComponent implements OnInit {
    @Input() public ParamObj;
    public ResumeApplicationForm: FormGroup;
    public MobileNumber: string;
    public IsErrorOTP: boolean;
    public IsServiceFailure: boolean;
    public ResendOtpExceedFlag = false;
    public ShowOTPField = false;
    public IsMobileValid = false;
    public WrongOtpMsg: string = null;
    public ServiceOTPError: string;
    public incorrectOTP = 0;
    private outputPayload = {};
    public OTPResend = 0;
    private year: string;
    private month: string;
    private day: string;
    public IsOTPResend = false;
    public MobileOtpTrails = 0;
    public IsCorrectMobile: string = null;
    public ServiceError: string;
    public showLoader = false;
    public MainLoadingText = 'Stay with us. We\'re almost done...';
    constructor(
        public FormValidators: FormValidator,
        private _formBuilder: FormBuilder,
        private _httpInterceptor: HttpInterceptor,
        private _formatter: Formatter,
        private _activitiHandler: ActivitiHandlerService,
        private _routerService: RouteHandlerService,
        private _sharedService: SharedService,
        private _analyticsService: AnalyticsService,
        private _sessionStorage: SessionHandlerService
    ) { }
    // On Page Init
    public ngOnInit() {
        this.buildResumeApplicationForm();
        this.autoPopulateFields();
    }
    // Disabling Event
    public IsPaste(event) {
        event.preventDefault();
    }
    public SendMobileOTP(): void {
        this.getOTP(this.onOTPReceived);

    }
    public ResendOTP(formValue: FormData) {
        this.IsOTPResend = false;
        if (this.OTPResend === 4) {
            this.OTPResend = 5;
            this.IsOTPResend = true;
        }
        if (this.OTPResend !== 5) { // TODO - Need to change logic in future -Hema temp change
            this.getOTP(this.onResendOTPReceived);
            this.IsOTPResend = true;
            this.OTPResend++;
        }
        if (this.OTPResend >= 5) {
            this.ResendOtpExceedFlag = true;
        }
    }
    public NavigateToView() {
        this.showLoader = true;
        this.IsOTPResend = false;
        const outputPayload = this.createPayload();
        if (this.MobileOtpTrails >= 5) {
            this.ResendOtpExceedFlag = true;
            return;
        }
        let mob = this.ResumeApplicationForm.controls['mobile'].value;
        this._sharedService.setData(
            CommonConstants.SharedServiceDataKeys.WebsiteResumeMobileNumber, mob);
        this._httpInterceptor.Post(ConfigService.getInstance()
            .getConfigObject().APIURL.ValidatePostOtp, outputPayload)
            .subscribe((mtResponse: ActivitiModel.MTResponse<any>) => {
                if (!mtResponse.errorBean) {
                    this.setUserAuthToken(mtResponse.payload);
                    this._sessionStorage.SetSession(
                        CommonConstants.CookieKeys.JourneyType,
                        'Resume'
                    );
                    const ListingPayloadData = this.ListingPayload();
                    this._httpInterceptor.Post(ConfigService.getInstance()
                        .getConfigObject().APIURL.GoToAppListing, ListingPayloadData).subscribe((resp) => {
                            if (!resp.errorBean) {
                                this._routerService.RouteToNextTask(resp.nextTask.nextTaskKey);
                            } else {
                                this.ServiceError = 'Something went wrong. Please try again later';
                            }
                        });
                } else if (CommonConstants.errorCodes.includes(mtResponse.errorBean[0].errorCode)) {
                    this.MobileOtpTrails++;
                    this.ServiceOTPError = mtResponse.errorBean[0].errorMessage;
                    this.showLoader = false;
                } else {
                    this.MobileOtpTrails++;
                    this.WrongOtpMsg = 'Please provide a valid OTP.';
                    this.showLoader = false;
                }
            });
    }
    // Validate Mobile Number
    public ValidateMobile() {
        const mobileNo = this.ResumeApplicationForm
            .controls['mobile'].value;
        const test = /(\d)\1{9}/g;
        if (mobileNo && !this.FormValidators.FieldHasErrors(
            this.ResumeApplicationForm, 'mobile')) {
            if (mobileNo[0] === '6' || mobileNo[0] === '7' || mobileNo[0] === '8' || mobileNo[0] === '9') {
                this.IsCorrectMobile = null;
            } else {
                this.IsCorrectMobile = 'Mobile number should start with 6, 7, 8, 9';
            }
            if (mobileNo.match(test)) {
                this.IsCorrectMobile = 'Please provide valid mobile number.';
            }
        } else {
            this.IsCorrectMobile = null;
        }
    }
    public CheckValid() {
        this.ResetMsg();
        let checkflag = this.ResumeApplicationForm.controls['mobile'].valid && !this.IsCorrectMobile ? true : false;
        return checkflag;
    }
    public NextFocus(curr, next): void {
        setTimeout(() => {
            const val = curr['value'] || '';
            if (val.length >= 2) {
                next.focus();
            }
        });
    }
    public ResetMsg() {
        this.IsMobileValid = false;
        this.IsServiceFailure = false;
        this.IsErrorOTP = false;
    }
    private autoPopulateFields() {
        if (this.ParamObj) {
            this.MobileNumber = this.ParamObj.mobileNumber;
            if (this.ParamObj.OTP) {
                this.ShowOTPField = true;
                this.ResumeApplicationForm.patchValue({ otp: this.ParamObj.OTP });
            }
        }
    }
    // Building Form Group
    private buildResumeApplicationForm() {
        this.ResumeApplicationForm = this._formBuilder.group({
            mobile: ['', Validators.compose([Validators.required])],
            otp: ['', Validators.compose([Validators.required])],
        });
        this.ResumeApplicationForm.controls['mobile'].valueChanges.subscribe(() => {
            this.IsCorrectMobile = null;
        });
        this.ResumeApplicationForm.valueChanges.subscribe((updatedValue) => {
            this.WrongOtpMsg = null;
        });
    }
    private createPayload() {
        const InsProductType = this._sessionStorage.GetSession(CommonConstants.CookieKeys.InsProductType);
        if (this.ParamObj) {
            const outputPayload = {
                "applicationKey": this._sessionStorage.GetSession(CommonConstants.CookieKeys.applicationId),
                "dateOfBirth": null,
                "mobile": this.MobileNumber,
                "otp": this.ResumeApplicationForm.controls['otp'].value,
                "productcatcode": InsProductType ? InsProductType : 'HGI',
                "source": 'journey',
                "stage": null
            }
            return outputPayload;
        } else {
            const outputPayload = {
                "applicationKey": this._sessionStorage.GetSession(CommonConstants.CookieKeys.applicationId),
                "dateOfBirth": null,
                "mobile": this.ResumeApplicationForm.controls['mobile'].value,
                "otp": this.ResumeApplicationForm.controls['otp'].value,
                "productcatcode": InsProductType ? InsProductType : 'HGI',
                "source": 'journey',
                "stage": null
            }
            return outputPayload;
        }
    }
    private getFormValuesAsPayload(isActivityCall?: boolean) {
        const outputPayload = {};
        if (this.ParamObj) {
            outputPayload['mobile'] = this.MobileNumber;
            outputPayload['productCode'] = CommonConstants.LOAN_PRODUCT_CODES.Health_Insurance;
            outputPayload['insProductType'] = CommonConstants.InsProductType;
            return outputPayload;
        } else {
            outputPayload['mobile'] = this.ResumeApplicationForm.controls['mobile'].value;
            outputPayload['otp'] = this.ResumeApplicationForm.controls['otp'].value;
            outputPayload['productCode'] = CommonConstants.LOAN_PRODUCT_CODES.Health_Insurance;
            outputPayload['insProductType'] = CommonConstants.InsProductType;
            return outputPayload;
        }
    }
    private setUserAuthToken(responseData: any) {
        if (responseData) {
            this._sessionStorage.SetSession(CommonConstants.CookieKeys.JWToken,
                responseData.tokens[0].token);
            this._sessionStorage.SetSession(CommonConstants.CookieKeys.GuardKey,
                responseData.tokens[0].guardKey);
            this._sessionStorage.SetSession(CommonConstants.CookieKeys.GuardToken,
                this._formatter
                    .ConvertGuradKeyToGuardToken(
                        responseData.tokens[0].guardKey));
        }
    }
    private onResendOTPReceived(mtResponse: ActivitiModel.MTResponse<any>) {
        if (mtResponse.errorBean) {
            this.IsServiceFailure = true;
        }
    }
    private onOTPReceived(mtResponse: ActivitiModel.MTResponse<any>) {
        if (!mtResponse.errorBean) {
            this.ShowOTPField = true;
        }
    }
    private ListingPayload() {
        return {
            'action': 'Navigate',
        };

    }
    private getOTP(callback): void {
        this.outputPayload = this.getFormValuesAsPayload();
        this.outputPayload['otp'] = CommonConstants.DEFAULT_EMPTY_STRING;
        this.outputPayload['source'] = CommonConstants.SourceTypes.Journey;
        this.outputPayload['mfa'] = true;
        this.outputPayload['notificationTypeCode'] = 'IMHLTHMOBILEOTP';
        this._httpInterceptor.Post(ConfigService.getInstance()
            .getConfigObject().APIURL.resumeGetOtp, this.outputPayload)
            .subscribe((response) => {
                if (!response.errorBean) {
                    callback.call(this, response);
                } else if (CommonConstants.errorCodes.includes(response.errorBean[0].errorCode)) {
                    this.IsOTPResend = false;
                    this.ServiceError = response.errorBean[0].errorMessage;
                }
            });
    }
    private initProcess(onSuccessCallback: Function) {
        const productCode = this._sharedService.getData(
            CommonConstants.QueryParamsKeys.Productcode); // this.getProductCode();
        this.startActivitiWithApplicationCreate(
            productCode,
            CommonConstants.LOAN_PRODUCT_CATEGORY_CODES.Health_Insurance,
            (mtResponse: Model.MTResponse<any>) => {
                onSuccessCallback(mtResponse);
            });
    }
    private startActivitiWithApplicationCreate(
        loanProduct: string,
        productCategoryCode: string,
        onSuccessCallback: Function,
        calculatorProductType?: number,
        isLocationProvided?: boolean) {
        const startActivitiRequest: any = {
            activitiName: 'startFlow',
            payload: this.getApplicationCreateRequest(
                loanProduct, productCategoryCode, calculatorProductType, isLocationProvided)
        };
        this.startActiviti(startActivitiRequest, onSuccessCallback);
    }
    private getApplicationCreateRequest(
        LoanProduct: string,
        ProductCategoryCode: string,
        CalculatorProductType?: number,
        IsLocationProvided?: boolean) {
        let mediumFromWeb = this._sharedService.getData(CommonConstants.QueryParamsKeys
            .appUtmMedium);
        const medium = 'Webengage_repeat_visitor_finance_homepage_PL_apply_online_link';
        if (mediumFromWeb !== '' && typeof (mediumFromWeb) !== 'object') {
            mediumFromWeb = this.CheckUtmMediumForDevice(
                this._sharedService.getData(CommonConstants.QueryParamsKeys
                    .appUtmMedium).toString());
        } else if (mediumFromWeb !== '') {
            mediumFromWeb = this.CheckUtmMediumForDevice(medium);
        } else {
            mediumFromWeb = this.CheckUtmMediumForDevice(mediumFromWeb);
        }
        return {
            appJourneyStamp: 'journeyStamp',
            appSource: 'Browser',
            appStatus: 0,
            bflBranch: this.checkUtmSources(this._sharedService.getData(
                CommonConstants.QueryParamsKeys.BFLBranch)) || '320',
            productCategoryCode: ProductCategoryCode,
            insuranceApplications: {
                insProduct: CommonConstants.LOAN_PRODUCT_CODES.Health_Insurance
            },
            appUtmRefCode: this.checkUtmSources(this._sharedService.getData(
                CommonConstants.QueryParamsKeys.appUtmRefCode)) || '',
            appUtmSource: this.checkUtmSources(this._sharedService.getData(
                CommonConstants.QueryParamsKeys.appUtmSource)) || 'Organic',
            appUtmMedium: mediumFromWeb || medium,
            appUtmCampaign: this.checkUtmSources(this._sharedService.getData(
                CommonConstants.QueryParamsKeys.appUtmCampaign)) || '',
            appUtmTerm: this.checkUtmSources(this._sharedService.getData(
                CommonConstants.QueryParamsKeys.appUtmTerm)) || '',
            appUtmContent: this.checkUtmSources(this._sharedService.getData(
                CommonConstants.QueryParamsKeys.appUtmContent)) || '',
            gclId: this.checkUtmSources(this._sharedService.getData(
                CommonConstants.QueryParamsKeys.GCLID))
                || 'EAIaIQobChMIsZGIyZn01AIV1IdoCh19HAKqEAAYASAAEgKWjfD_BwE',
            applicantId: this.checkUtmSources(this._sharedService.getData(
                CommonConstants.QueryParamsKeys.ApplicantId)) || '',
            applicationId: this.checkUtmSources(this._sharedService.getData(
                CommonConstants.QueryParamsKeys.ApplicationId)) || '',
            appApplicantId: this.checkUtmSources(this._sharedService.getData(
                CommonConstants.QueryParamsKeys.ApplicationApplicantId)) || '',
            emailQuote: false,
            resumeJourney: true
        };
    }
    private checkUtmSources(utmObj) {
        if (Object.keys(utmObj).length !== 0) {
            return utmObj;
        } else {
            return false;
        }
    }
    private CheckUtmMediumForDevice(value: string) {
        const deviceDetails: DeviceDetails = this._analyticsService.GetDeviceDetails();
        if (deviceDetails.mobile) {
            value = value.concat('_mobile');
        }
        return value;
    }
    private startActiviti(request: any, onSuccessCallback: Function) {
        this._activitiHandler.StartActiviti(request, true)
            .subscribe((data: ActivitiModel.ActivitiResponse) => {
                console.log('Raw Activiti working now');
                if (!data.errorBean) {
                    this._sessionStorage.SetSession(CommonConstants.CookieKeys.applicationId,
                        data.payload.applicationKey);
                    this._sessionStorage.SetSession(CommonConstants.CookieKeys.ProcessInstanceDetails,
                        data.payload.processInstanceDetails);
                    this._sessionStorage.SetSession(CommonConstants.CookieKeys.LoanApplicationKey,
                        data.payload.loanApplicationKey);
                    onSuccessCallback(data);
                }
            },
                (Error) => {
                    console.log(Error);
                });
    }
}
